// extracted by mini-css-extract-plugin
export var dividerContainer = "_ai-0";
export var line = "_ai-1";